import { SalutationItemResponse, SalutationResponseList } from '@/types/service-response'

export class Salutation {
  public constructor (
    readonly id: number,
    readonly gender: number,
    readonly name: string
  ) {}

  static createFromResponse (responseData: SalutationResponseList): Array<Salutation> {
    let result: Array<Salutation> = []
    if (responseData) {
      result = responseData.map((item: SalutationItemResponse ) => {
        return new Salutation(
          item.ID,
          item.Geschlecht,
          item.Bezeichnung
        )
      })
    }
    return result
  }
}
